import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA3 from 'react-ga';
import { message } from 'antd';
import { Provider } from 'react-redux';
import RouterConfig from './router';
import store from './redux/store';
import Utils from '@/utils/utils';
import { version } from '@/constants/common';
import '@/locales/i18n';
import '@/assets/App.less';
import '@/assets/App-ar.less';
import ReactGA from 'react-ga4';
//GA配置
// ReactGA.initialize("UA-177200317-10");
ReactGA3.initialize([
  { trackingId: 'UA-216947947-1', gaOptions: { name: 'OnlineTracker' } },
  { trackingId: 'UA-177200317-10', gaOptions: { name: 'Tracker' } },
]);
ReactGA.initialize([
  { trackingId: 'G-H0XX3640GF', gaOptions: { name: 'OnlineGa4Tracker' } },
]);

ReactGA3.pageview(window.location.pathname);
ReactGA3.set(
  {
    dimension1: version,
    dimension3: 'none',
    dimension4: Utils.getLanguage(),
  },
  ['OnlineTracker', 'Tracker']
);

document.documentElement.setAttribute('lang', Utils.getLanguage());

//全局定制message
message.config({
  duration: 5,
  top: 24,
});

ReactDOM.render(
  <Provider store={store}>
    <RouterConfig />
  </Provider>,
  document.getElementById('root')
);
